const backendUrl = "";
const defaultEndpoint = "";

const restrictions = {
    MIN_DATE_TO_MAKE_ORDER: new Date()
};

export const environment = {
    backendUrl: backendUrl,
    baseUrl: defaultEndpoint,
    businessRules: restrictions
};